import { videoTool } from '../util/index';
/** video性能监控模块 */
var PerformanceMonitor = /** @class */ (function () {
    function PerformanceMonitor(video) {
        /** video标签返回的总帧数 */
        this.totalVideoFrames = 0;
        /** video标签返回的丢帧数 */
        this.droppedVideoFrames = 0;
        /** RVFC返回的帧处理总耗时 */
        this.totalDecodeTimeInMs = 0;
        /** RVFC返回的渲染总帧数 */
        this.presentedVideoFrames = 0;
        this.preTotalVideoFrames = -1;
        this.preDroppedVideoFrames = -1;
        this.calcIntervalFrameDroppedTickCount = 0;
        this.video = video;
    }
    /**
     * 在timeupdate中循环调用计算瞬时帧率
     */
    PerformanceMonitor.prototype.calcIntervalFrameDropped = function () {
        var TIMEUPDATE_TICK_COUNT = 5;
        this.calcIntervalFrameDroppedTickCount++;
        if (this.calcIntervalFrameDroppedTickCount < TIMEUPDATE_TICK_COUNT) {
            // TIMEUPDATE_TICK_COUNT个timeupdate事件，计算一次帧率
            return;
        }
        this.calcIntervalFrameDroppedTickCount = 0;
        if (this.preVisiblityState !== document.visibilityState) {
            // 当页面可见发生变化时，重置初始值。例如从后台切回前台时。
            this.reset();
        }
        else if (this.preVisiblityState === 'visible') {
            var _a = videoTool.getVideoPlaybackQuality(this.video), totalVideoFrames = _a.totalVideoFrames, droppedVideoFrames = _a.droppedVideoFrames;
            // 初始值的时候，记录当前值
            if (this.preTotalVideoFrames === -1) {
                this.preTotalVideoFrames = totalVideoFrames;
            }
            if (this.preDroppedVideoFrames === -1) {
                this.preDroppedVideoFrames = droppedVideoFrames;
            }
            // 开始计算每个timeupdata之间帧指标的差值
            var diffTotalVideoFrames = totalVideoFrames - this.preTotalVideoFrames;
            var diffDroppedVideoFrames = droppedVideoFrames - this.preDroppedVideoFrames;
            this.preTotalVideoFrames = totalVideoFrames;
            this.preDroppedVideoFrames = droppedVideoFrames;
            if (diffTotalVideoFrames > 0) {
                return diffDroppedVideoFrames / diffTotalVideoFrames;
            }
        }
        return 0;
    };
    PerformanceMonitor.prototype.reset = function () {
        this.preTotalVideoFrames = -1;
        this.preDroppedVideoFrames = -1;
        this.preVisiblityState = document.visibilityState;
    };
    PerformanceMonitor.prototype.report = function () {
        var _a = videoTool.getVideoPlaybackQuality(this.video), totalVideoFrames = _a.totalVideoFrames, droppedVideoFrames = _a.droppedVideoFrames;
        this.totalVideoFrames = totalVideoFrames;
        this.droppedVideoFrames = droppedVideoFrames;
        var averageDecodeTimeInMs = this.totalDecodeTimeInMs / this.presentedVideoFrames;
        if (isNaN(averageDecodeTimeInMs)) {
            averageDecodeTimeInMs = -1;
        }
        var frameDroppedInPercentage = (this.droppedVideoFrames / this.totalVideoFrames) * 100;
        if (isNaN(frameDroppedInPercentage)) {
            frameDroppedInPercentage = -1;
        }
        return {
            totalDecodeTimeInMs: this.totalDecodeTimeInMs,
            droppedVideoFrames: this.droppedVideoFrames,
            presentedVideoFrames: this.presentedVideoFrames,
            totalVideoFrames: this.totalVideoFrames,
            averageDecodeTimeInMs: averageDecodeTimeInMs,
            frameDroppedInPercentage: frameDroppedInPercentage,
        };
    };
    return PerformanceMonitor;
}());
export { PerformanceMonitor };
